import { Box } from "@mui/material";
import VidletButterfly from "components/Icons/VidletButterfly";

export default function AnimatedButterfly() {
  return (
    <Box
      sx={{
        "@keyframes flap": {
          "0%": { transform: "scale(1,1)" },
          "50%": { transform: "scale(.25,1)" },
          "100%": { transform: "scale(1,1)" },
        },
        animation: "flap .45s infinite",
      }}
    >
      <VidletButterfly sx={{ zIndex: 1, width: 100, height: 50 }} />
    </Box>
  );
}
